import cx from 'classnames'
import React, { useEffect } from 'react'

import CTA from '@f/elements/CTA'

import HardRequest from './partials/HardRequest'

const LocationOK = ({ hardRequestVendors = [], ...props }) => {
  useEffect(() => {
    props.actions.update_wtValue({ value: 'hard-request' })
    props.actions.completeProgressBar()
  }, [])

  let selectedVendors = hardRequestVendors.filter(el => el.isSelected)

  let buttonText
  switch (selectedVendors.length) {
    case 0:
      buttonText = 'Bitte mindestens einen Anbieter auswählen'
      break
    case 1:
      buttonText = 'Einen Anbieter anfragen und weiter'
      break
    default:
      buttonText = `${selectedVendors.length} Anbieter anfragen und weiter`
  }
  const isConversionFunnel = Boolean(props.funnelVariant)

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-040'
      )}>
      <div className='RequestWizard-top'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Diese Anbieter können ähnliche Häuser bauen
          </div>
          <div className='[ f-t-body f-c-fo-pri f-t-centre f-m-t-005 f-p-h-080:m ]'>
            Um Ihr Angebot besser beurteilen zu können, empfehlen wir Ihnen auch
            Informationen zu Häusern dieser Anbieter anzufordern.
          </div>
        </div>

        <div className='RequestWizard-content'>
          <HardRequest hardRequestVendors={hardRequestVendors} {...props} />
        </div>
      </div>

      <div className='RequestWizard-bottom'>
        <p className='[ f-t-centre f-t-micro f-c-fo-neu200 f-m-v-010 ]'>
          Mehr Informationen zur Datenverarbeitung und zur Übermittlung Ihrer
          Daten an unsere Partner erhalten Sie in unserer{' '}
          <CTA
            type='text-primary'
            tag='a'
            href='/datenschutz/'
            target='_blank'
            className='internal'>
            Datenschutzerklärung
          </CTA>
          . Wir senden Ihnen anschließend eine Bestätigungsmail, die Ihnen die
          übersandten Daten zeigt. Ihre Anfrage ist jederzeit freiwillig,
          kostenlos und unverbindlich.
        </p>
        <CTA
          type='block-primary'
          tag='button'
          buttonType='submit'
          data-sel='btn-cta'
          className='[ f-m-h-auto f-m-t-020 ] is-block:s'
          onClick={
            selectedVendors.length > 0
              ? props.actions.subStepRedirect
              : undefined
          }>
          {buttonText}
        </CTA>
      </div>
    </div>
  )
}

export default LocationOK
